const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
const hasText = value => Object.values(value || {}).some(text => String(text || '').replace(/<[^>]*>/g, '').replace(/&nbsp;|\s/g, '').length > 0);
const hasAmount = value => value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value));

export const projectFeatureDefinitions = [
  { key: 'description', yes: 'has-description', no: 'no-description', icons: ['mdi-card-bulleted', 'mdi-card-bulleted-off'], color: 'blue' },
  { key: 'objectives', yes: 'has-objectives', no: 'no-objectives', icons: ['mdi-cog-outline', 'mdi-cog-off'], color: 'purple' },
  { key: 'results', yes: 'has-results', no: 'no-results', icons: ['mdi-chart-box-outline', 'mdi-chart-box'], color: 'blue' },
  { key: 'image', yes: 'has-image', no: 'no-image', icons: ['mdi-image-outline', 'mdi-image-off'], color: 'green' },
  { key: 'subprojects', yes: 'has-subprojects', no: 'no-subprojects', icons: ['mdi-human-male-female-child', 'mdi-human-child'], color: 'black' },
  { key: 'consortium', yes: 'has-consortium', no: 'no-consortium', icons: ['mdi-vector-circle', 'mdi-vector-circle-variant'], color: 'black' },
  { key: 'financial', yes: 'has-financial-info', no: 'no-financial-info', icons: ['mdi-cash-check', 'mdi-cash-remove'], color: 'teal' },
  { key: 'hidden', yes: 'hidden', no: 'visible', icons: ['mdi-eye-off', 'mdi-eye-outline'], color: 'red' },
  { key: 'external', yes: 'external', no: 'internal', icons: ['mdi-alien', 'mdi-alien-outline'], color: 'pink' },
  { key: 'featured', yes: 'featured', no: 'not-featured', icons: ['mdi-alert-octagram', 'mdi-alert-octagram-outline'], color: 'purple' }
];

export function projectFeatures(project) {
  return {
    description: hasText(project.description), objectives: hasText(project.objectives), results: hasText(project.results),
    image: Boolean(project.image), subprojects: Boolean(project.subprojects && project.subprojects.length),
    consortium: project.consortium !== null && project.consortium !== undefined,
    financial: hasAmount(project.total_budget) || hasAmount(project.citius_budget),
    hidden: Boolean(project.hidden), external: project.external === true, featured: Boolean(project.featured),
    areas: Boolean(project.research_areas && project.research_areas.length),
    code: Boolean(project.code), doi: Boolean(project.doi)
  };
}

export function matchesProjectSearch(project, search) {
  const features = projectFeatures(project);
  const tokens = new Set(projectFeatureDefinitions.map(def => features[def.key] ? def.yes : def.no));
  ['areas', 'code', 'doi'].forEach(key => tokens.add(`${features[key] ? 'has' : 'no'}-${key}`));
  const known = new Set(projectFeatureDefinitions.flatMap(def => [def.yes, def.no]).concat(['has-areas', 'no-areas', 'has-code', 'no-code', 'has-doi', 'no-doi']));
  const text = normalize([...Object.values(project.title || {}), project.acronym, project.code, project.doi].filter(Boolean).join(' '));
  return normalize(search).split(',').map(term => term.trim()).filter(Boolean).every(term => {
    if (known.has(term)) return tokens.has(term);
    if (term.startsWith('code:')) return normalize(project.code).includes(term.slice(5));
    if (term.startsWith('doi:')) return normalize(project.doi).includes(term.slice(4));
    if (term.startsWith('year:')) {
      const year = Number(term.slice(5));
      const start = new Date(project.start_date).getFullYear();
      const end = new Date(project.end_date).getFullYear();
      return /^year:\d{4}$/.test(term) && year >= start && year <= end;
    }
    return text.includes(term);
  });
}
